import _ from 'lodash'

export const buildReplaceRegex = (stringsToReplace: string[]): RegExp =>
    new RegExp(
        stringsToReplace.map(stringToReplace => _.map(stringToReplace, char => `\\${char}`).join('')).join('|'),
        'g'
    )

export const createCharReplacementFunc = (replacementsMap: Record<string, string>) => {
    const replaceRegex = buildReplaceRegex(Object.keys(replacementsMap))
    return (property: string): string => property.replace(replaceRegex, char => replacementsMap[char])
}
